import InstallPrompt from "../../components/InstallPrompt";
import React, { useState, useEffect } from "react";
import { api } from "../../utils/api";
import ResidentHome from "./ResidentHome";
import ResidentPayment from "./ResidentPayment";
import { BarChart2, Wallet, Headphones, Settings, Printer,  } from "lucide-react";
import { Edit2, Save, X, User } from "lucide-react";

// Para ve Tarih formatlayıcı araçlar
const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
const money2 = n => new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
const fmt = d => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function ResidentApp({ resident }) {
  const [activeTab, setActiveTab] = useState("home");
  
  return (
    <div className="mobile-app-shell dark-theme">
      <main className="mobile-content">
        <InstallPrompt />
        {/* setActiveTab prop olarak ResidentHome'a geçiriliyor */}
        {activeTab === "home" && <ResidentHome resident={resident} setActiveTab={setActiveTab} />}
        {activeTab === "islemler" && <ResidentTransactions resident={resident} />}
        {activeTab === "destek" && <ResidentSupport resident={resident} />}
        {activeTab === "profil" && <ResidentProfile resident={resident} />}
        {/* YENİ ÖDEME SAYFASI BAĞLANTISI */}
        {activeTab === "payment" && <ResidentPayment resident={resident} setActiveTab={setActiveTab} />}
      </main>
      
      {/* Yeni Koyu Tema Alt Navigasyon */}
      <nav className="bottom-nav dark-nav">
        <button className={activeTab === "home" ? "active" : ""} onClick={() => setActiveTab("home")}>
          <BarChart2 size={22} /><span>Pano</span>
        </button>
        <button className={activeTab === "islemler" ? "active" : ""} onClick={() => setActiveTab("islemler")}>
          <Wallet size={22} /><span>Ödemeler</span>
        </button>
        <button className={activeTab === "destek" ? "active" : ""} onClick={() => setActiveTab("destek")}>
          <Headphones size={22} /><span>Talepler</span>
        </button>
        <button className={activeTab === "profil" ? "active" : ""} onClick={() => setActiveTab("profil")}>
          <Settings size={22} /><span>Hesabım</span>
        </button>
      </nav>
    </div>
  );
}

// FİNANS (İŞLEMLER) SEKMESİ - Çift Tarihli Tablo ve Yazdırılabilir PDF
// FİNANS (İŞLEMLER) SEKMESİ - Çift Tarihli Tablo ve Yazdırılabilir PDF
function ResidentTransactions({ resident }) {
  const [balanceData, setBalanceData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. DÜZELTME: Çerezleri (Cookie) gönderen fetch yapısı eklendi
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const apiUrl = `https://api.baskentsitesi.com.tr/api/statement/${resident.accounting_code}`;
        
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          // Pano sayfasındaki sorunu çözen sihirli ayar
          credentials: 'include' 
        });

        if (!response.ok) {
          throw new Error(`Sunucu Hatası: ${response.status}`);
        }

        const data = await response.json();
        setBalanceData(data); 

      } catch (error) {
        console.error("Hesap dökümü çekilemedi:", error);
      } finally {
        setLoading(false);
      }
    };

    if (resident && resident.accounting_code) {
      fetchTransactions();
    } else {
      setLoading(false);
    }
  }, [resident]);

  const handlePrint = () => {
    window.print();
  };

  // 2. DÜZELTME: balanceData içindeki 'rows' dizisi gelmeden tabloyu çizmesini engelleyen güvenli kontrol
  if (loading) return <div className="resident-home-dark" style={{padding:"40px", textAlign:"center", color:"#94a3b8"}}>Veriler yükleniyor...</div>;
  if (!balanceData || !balanceData.rows) return <div className="resident-home-dark" style={{padding:"40px", textAlign:"center", color:"#ef4444"}}>Veri alınamadı.</div>;

  const shortMonths = { "Ocak": "Oca", "Şubat": "Şub", "Mart": "Mar", "Nisan": "Nis", "Mayıs": "May", "Haziran": "Haz", "Temmuz": "Tem", "Ağustos": "Ağu", "Eylül": "Eyl", "Ekim": "Eki", "Kasım": "Kas", "Aralık": "Ara" };

  // ... Kodun geri kalanı (getShortMonthYear ve buildTable) aynı şekilde devam edecek ...
  const getShortMonthYear = (dateString, fallbackAy, fallbackYil) => {
    if (dateString) {
      let dStr = String(dateString).split(',')[0].trim();
      if (/^\d{2}\.\d{2}\.\d{4}/.test(dStr)) {
        const [day, m, y] = dStr.substring(0,10).split('.');
        const mIndex = parseInt(m, 10) - 1;
        const mName = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"][mIndex];
        return `${mName} ${y.slice(2)}`;
      } else if (/^\d{4}-\d{2}-\d{2}/.test(dStr)) {
        const [y, m] = dStr.substring(0,10).split('-');
        const mIndex = parseInt(m, 10) - 1;
        const mName = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"][mIndex];
        return `${mName} ${y.slice(2)}`;
      }
    }
    const sAy = shortMonths[fallbackAy] || fallbackAy?.slice(0,3) || fallbackAy || "";
    const sYil = fallbackYil ? fallbackYil.toString().slice(-2) : "";
    return `${sAy} ${sYil}`.trim();
  };

  // Dinamik Tablo Oluşturucu
  const buildTable = (cutoffDate) => {
    let devir = 0;
    let rows = [];
    let cumulative = 0;

    balanceData.rows.forEach(r => {
      let dateToCheck = new Date("2000-01-01");
      const rawDate = r.aidat_date || (typeof r.payment_date === 'string' ? r.payment_date.split(',')[0] : r.payment_date);
      
      if (rawDate) {
         let dStr = String(rawDate).trim();
         if (/^\d{2}\.\d{2}\.\d{4}/.test(dStr)) {
             const [day, m, y] = dStr.substring(0,10).split('.');
             dateToCheck = new Date(`${y}-${m}-${day}`);
         } else if (/^\d{4}-\d{2}-\d{2}/.test(dStr)) {
             dateToCheck = new Date(dStr.substring(0,10));
         }
      }

      if (r.ay === "Devir" || dateToCheck < cutoffDate) {
        let pAmt = 0;
        if (typeof r.payment_amount === 'string') {
           pAmt = r.payment_amount.split(',').reduce((sum, v) => sum + (Number(v.trim()) || 0), 0);
        } else {
           pAmt = r.payment_amount || 0;
        }
        devir += (r.aidat_amount || 0) + (r.extra_amount || 0) - pAmt;
      } else {
        rows.push(r);
      }
    });

    cumulative = devir;

    const processedRows = rows.map(r => {
      const aidat = (r.aidat_amount || 0) + (r.extra_amount || 0);
      let pAmt = 0;
      if (typeof r.payment_amount === 'string') {
          pAmt = r.payment_amount.split(',').reduce((sum, v) => sum + (Number(v.trim()) || 0), 0);
      } else {
          pAmt = r.payment_amount || 0;
      }
      cumulative += aidat - pAmt;
      
      return { 
        ...r, 
        cumulative, 
        totalAidat: aidat, 
        odemeTarihi: r.payment_date, 
        odemeTutari: r.payment_amount 
      };
    });

    return { devir, rows: processedRows };
  };

  const screenData = buildTable(new Date("2026-06-01"));
  const pdfData = buildTable(new Date("2026-01-01"));

  const fmtMoney = (val) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(val);

  const hasValue = (val) => {
    if (!val) return false;
    if (typeof val === 'number') return val > 0;
    if (typeof val === 'string') return val.split(',').some(p => Number(p.trim()) > 0);
    return false;
  };

  const formatStackedDate = (dateStr) => {
    if (!dateStr) return "-";
    return String(dateStr).split(',').map((d, idx) => {
      let str = d.trim();
      if (!str) return null;
      if (/^\d{2}\.\d{2}\.\d{4}/.test(str)) {
        return <div key={idx} style={{marginBottom: "4px"}}>{str.substring(0,10)}</div>;
      }
      if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
        const [y, m, day] = str.substring(0,10).split('-');
        return <div key={idx} style={{marginBottom: "4px"}}>{`${day}.${m}.${y}`}</div>;
      }
      return <div key={idx} style={{marginBottom: "4px"}}>{str}</div>;
    });
  };

  const formatStackedMoney = (val) => {
    if (!hasValue(val)) return "-";
    if (typeof val === 'number') return fmtMoney(val);
    
    return String(val).split(',').map((v, idx) => {
      let num = Number(v.trim());
      if (!isNaN(num) && num > 0) {
        return <div key={idx} style={{marginBottom: "4px"}}>{fmtMoney(num)}</div>;
      }
      return null;
    });
  };

  return (
    <div className="resident-home-dark resident-finans-container" style={{ animation: "fadeIn 0.3s ease-out", paddingBottom: "100px" }}>
      
      <style>{`
        .finans-table-wrapper {
          background: white;
          border-radius: 12px;
          padding: 16px 12px;
          margin-bottom: 20px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          overflow-x: auto;
        }
        .finans-table {
          width: 100%;
          border-collapse: collapse;
          text-align: center;
          white-space: nowrap;
        }
        .finans-table th {
          background: #f1f5f9;
          color: #475569;
          font-size: 11px;
          padding: 12px 8px;
          border-bottom: 2px solid #cbd5e1;
        }
        .finans-table td {
          padding: 12px 8px;
          font-size: 13px;
          color: #1e293b;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
        }
        .finans-table tr:nth-child(even) { background: #f8fafc; }
        .finans-table tr:nth-child(odd) { background: #ffffff; }
        .finans-table td:last-child { font-weight: bold; color: #0f172a; }

        @media print {
          body, .mobile-app-shell, .resident-home-dark { background: white !important; color: black !important; min-height: auto !important; padding: 0 !important; }
          .bottom-nav, .no-print-area { display: none !important; }
          .resident-finans-container { padding: 0 !important; margin: 0 !important; }
          .print-area { display: block !important; width: 100%; }
          .print-header { text-align: center; margin-bottom: 30px; margin-top: 20px; }
          .print-table { width: 100%; border-collapse: collapse; font-size: 12px; }
          .print-table th, .print-table td { border: 1px solid #333; padding: 8px; text-align: center; color: black !important; vertical-align: middle; }
          .print-table th { background-color: #f3f4f6 !important; -webkit-print-color-adjust: exact; }
        }
        .print-area { display: none; }
      `}</style>

      {/* ================= MOBİL EKRAN GÖRÜNÜMÜ ================= */}
      <div className="no-print-area">
        <h3 className="section-heading" style={{color:"white", marginBottom: "16px"}}>Hesap Dökümü</h3>
        
        <div className="finans-table-wrapper">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', fontSize: '14px', fontWeight: 'bold', color: '#1e293b', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
            <span>Hesap No: {resident.accounting_code}</span>
            <span>Adı Soyadı: {resident.name}</span>
          </div>
          
          <table className="finans-table">
            <thead>
              <tr>
                <th>Aylar</th>
                <th>Aidat Tutarı</th>
                <th>Ödeme Tarihi</th>
                <th>Ödeme Tutarı</th>
                <th>Bakiye</th> 
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{fontWeight: "bold"}}>May 26</td>
                <td style={{color: "#64748b"}}>(Devir)</td>
                <td>-</td>
                <td>-</td>
                <td>{fmtMoney(screenData.devir)}</td>
              </tr>
              
              {screenData.rows.map((r, i) => (
                <tr key={i}>
                  <td style={{fontWeight: "bold"}}>{getShortMonthYear(r.aidat_date, r.ay, r.yil)}</td>
                  <td>{r.totalAidat > 0 ? fmtMoney(r.totalAidat) : "-"}</td>
                  <td style={{color: "#64748b"}}>{formatStackedDate(r.odemeTarihi)}</td>
                  <td style={{color: "#10b981"}}>{formatStackedMoney(r.odemeTutari)}</td>
                  <td>{fmtMoney(r.cumulative)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= PDF (YAZDIRMA) GÖRÜNÜMÜ ================= */}
      <div className="print-area">
        <div className="print-header">
          <h1 style={{fontSize: "20px", margin: "0 0 8px 0"}}>BAŞKENT SİTESİ HESAP DÖKÜMÜ</h1>
          <p style={{margin: "4px 0"}}><strong>Hesap No:</strong> {resident.accounting_code} | <strong>Adı Soyadı:</strong> {resident.name}</p>
          <p style={{margin: "4px 0"}}><strong>Rapor Tarihi:</strong> {new Date().toLocaleString("tr-TR")}</p>
        </div>
        
        <table className="print-table">
          <thead>
            <tr>
              <th>AYLAR</th>
              <th>AİDAT TUTARI</th>
              <th>ÖDEME TARİHİ</th>
              <th>ÖDEME TUTARI</th>
              <th>BAKİYE</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{background: "#f8fafc"}}>
              <td style={{fontWeight: "bold"}}>31.12.2025</td>
              <td>(Devir)</td>
              <td>-</td>
              <td>-</td>
              <td style={{fontWeight: "bold"}}>{fmtMoney(pdfData.devir)}</td>
            </tr>
            
            {pdfData.rows.map((r, i) => (
              <tr key={i}>
                <td>{getShortMonthYear(r.aidat_date, r.ay, r.yil)}</td>
                <td>{r.totalAidat > 0 ? fmtMoney(r.totalAidat) : "-"}</td>
                <td>{formatStackedDate(r.odemeTarihi)}</td>
                <td>{formatStackedMoney(r.odemeTutari)}</td>
                <td style={{fontWeight: "bold"}}>{fmtMoney(r.cumulative)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button 
        onClick={handlePrint}
        className="no-print-area"
        style={{
          position: "fixed",
          bottom: "90px",
          right: "20px",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "#3b82f6",
          color: "white",
          border: "none",
          boxShadow: "0 4px 15px rgba(59, 130, 246, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          zIndex: 1000,
          transition: "transform 0.2s"
        }}
        onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
        onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
      </button>
    </div>
  );
}

// TALEPLER SEKMESİ
function ResidentSupport({ resident }) {
  const [showAdForm, setShowAdForm] = useState(false);
  const [adForm, setAdForm] = useState({ type: "Talep / Şikayet", notes: "" });

  const handleAdSubmit = (e) => {
    e.preventDefault();
    alert("Talebiniz site yönetimine iletildi.");
    setShowAdForm(false);
    setAdForm({ ...adForm, notes: "" });
  };

  return (
    <div className="resident-home-dark">
      <h3 className="section-heading">Talepler ve İlanlar</h3>
      
      <div className="emerald-card" style={{ background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)", padding: "20px" }}>
        <h3 style={{ color: "white", marginBottom: "8px", fontSize: "16px" }}>Site sakinlerine veya yönetime özel talep ve ilan bırakabilirsiniz.</h3>
        
        <button onClick={() => setShowAdForm(true)} style={{ background: "#3b82f6", color: "white", border: "none", padding: "10px 16px", borderRadius: "8px", fontWeight: "bold", cursor: "pointer", width: "100%" }}>
          İlan Ekle / Talep Oluştur
        </button>
      </div>

      {showAdForm && (
        <div className="payment-modal" style={{ background: "#1e293b", color: "white", border: "1px solid #334155" }}>
          <h3 style={{ color: "white", marginBottom: "16px" }}>Talep / İlan Formu</h3>
          <form onSubmit={handleAdSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <label style={{ fontSize: "13px", fontWeight: "bold", color: "#cbd5e1" }}>İşlem Türü
              <select value={adForm.type} onChange={e => setAdForm({...adForm, type: e.target.value})} style={{ width: "100%", padding: "10px", marginTop: "4px", borderRadius: "6px", background: "#0f172a", color: "white", border: "1px solid #334155" }}>
                <option>Talep / Şikayet</option>
                <option>Satılık İlanı</option>
                <option>Kiralık İlanı</option>
              </select>
            </label>
            <label style={{ fontSize: "13px", fontWeight: "bold", color: "#cbd5e1" }}>Açıklama
              <textarea rows="3" value={adForm.notes} onChange={e => setAdForm({...adForm, notes: e.target.value})} placeholder="Detayları buraya yazın..." style={{ width: "100%", padding: "10px", marginTop: "4px", borderRadius: "6px", background: "#0f172a", color: "white", border: "1px solid #334155" }} required></textarea>
            </label>
            <button type="submit" style={{ background: "#10b981", color: "white", padding: "12px", border: "none", borderRadius: "6px", fontWeight: "bold", marginTop: "8px" }}>Gönder</button>
            <button type="button" onClick={() => setShowAdForm(false)} style={{ background: "transparent", color: "#94a3b8", padding: "12px", border: "none", fontWeight: "bold" }}>Vazgeç</button>
          </form>
        </div>
      )}
    </div>
  );
}


// HESABIM (PROFİL VE ŞİFRE) SEKMESİ
function ResidentProfile({ resident }) {
  const [profileData, setProfileData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ email: "", notification_address: "" });

  const loadProfile = () => {
    setLoading(true);
    api.get(`/resident/profile/${resident.accounting_code}`)
      .then(res => {
        setProfileData(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Profil çekilemedi:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadProfile();
  }, [resident.accounting_code]);

  // Düzenleme moduna geçerken form kutucuklarını mevcut veriyle doldurur
  useEffect(() => {
    if (profileData) {
      setFormData({
        email: resident.type === "Kiracı" 
          ? (profileData.resident_email || "") 
          : (profileData.owner_email || ""),
        notification_address: resident.type === "Kiracı" 
          ? (profileData.resident_notification_address || "") 
          : (profileData.owner_notification_address || "")
      });
    }
  }, [profileData, resident.type, editing]);

  const handleSave = async (e) => {
    e.preventDefault();
    const payload = {
      accounting_code: resident.accounting_code,
      role: resident.type,
      email: formData.email || "",
      notification_address: formData.notification_address || ""
    };

    try {
      await api.put("/resident/profile", payload);
      setEditing(false);
      loadProfile(); // Veriyi anında sunucudan yenile
      alert("Bilgileriniz başarıyla güncellendi.");
    } catch (err) {
      alert("Güncelleme başarısız: " + (err.response?.data?.detail || "Sunucu hatası."));
    }
  };

  if (loading) return <div className="resident-home-dark" style={{padding:"40px", textAlign:"center", color:"#94a3b8"}}>Profil yükleniyor...</div>;

  // Ekranda gösterilecek mevcut değerler (Kiracı / Malik ayrımına göre)
  const displayEmail = resident.type === "Kiracı" ? profileData?.resident_email : profileData?.owner_email;
  const displayAddress = resident.type === "Kiracı" ? profileData?.resident_notification_address : profileData?.owner_notification_address;

  return (
    <div className="resident-home-dark resident-finans-container" style={{ animation: "fadeIn 0.3s ease-out", paddingBottom: "100px" }}>
      
      <style>{`
        .profile-table-wrapper {
          background: white;
          border-radius: 12px;
          padding: 16px 12px;
          margin-bottom: 20px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .profile-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }
        .profile-table th {
          background: #f1f5f9;
          color: #475569;
          font-size: 12px;
          padding: 14px 12px;
          border-bottom: 1px solid #cbd5e1;
          border-right: 1px solid #e2e8f0;
          width: 35%;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .profile-table td {
          padding: 14px 12px;
          font-size: 14px;
          color: #1e293b;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
          word-break: break-word;
        }
        /* Zebra Deseni */
        .profile-table tr:nth-child(even) td { background: #f8fafc; }
        .profile-table tr:nth-child(odd) td { background: #ffffff; }

        .btn-modern {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          width: 100%; padding: 12px; border-radius: 8px; font-weight: 600; font-size: 14px;
          cursor: pointer; transition: all 0.2s; border: none; margin-top: 16px;
        }
        .btn-edit { background: #3b82f6; color: white; box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3); }
        .btn-save { background: #10b981; color: white; box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }
        .btn-cancel { background: #ef4444; color: white; margin-top: 8px; }
        
        .form-input-modern {
          width: 100%; padding: 12px; margin-top: 6px; margin-bottom: 16px;
          border-radius: 6px; background: #f8fafc; color: #0f172a;
          border: 1px solid #cbd5e1; font-family: inherit; font-size: 14px;
        }
        .form-input-modern:focus { outline: none; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
      `}</style>

      <div className="no-print-area">
        <h3 className="section-heading" style={{color:"white", marginBottom: "16px"}}>Profil Bilgileriniz</h3>
        
        {!editing ? (
          /* ================= GÖRÜNTÜLEME MODU (ZEBRA TABLO) ================= */
          <div className="profile-table-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', fontSize: '15px', fontWeight: 'bold', color: '#1e293b', borderBottom: '2px solid #e2e8f0', paddingBottom: '12px' }}>
              <User size={20} color="#3b82f6" /> Başkent Sitesi Sakin Profili
            </div>
            
            <table className="profile-table">
              <tbody>
                <tr>
                  <th>Hesap No</th>
                  <td style={{fontWeight: "bold"}}>{resident.accounting_code}</td>
                </tr>
                <tr>
                  <th>Adı Soyadı</th>
                  <td style={{fontWeight: "bold"}}>{resident.name}</td>
                </tr>
                <tr>
                  <th>Durum</th>
                  <td>{resident.type}</td>
                </tr>
                <tr>
                  <th>E-posta</th>
                  <td style={{ 
                    color: displayEmail ? "#1e293b" : "#94a3b8", 
                    fontWeight: displayEmail ? "500" : "normal" 
                  }}>
                    {displayEmail || "E-posta girilmemiş."}
                  </td>
                </tr>
                <tr>
                  <th>Tebligat Adresi</th>
                  <td style={{ 
                    color: displayAddress ? "#1e293b" : "#94a3b8", 
                    fontWeight: displayAddress ? "500" : "normal" 
                  }}>
                    {displayAddress || "Tebligat adresi girilmemiş."}
                  </td>
                </tr>
              </tbody>
            </table>

            <button className="btn-modern btn-edit" onClick={() => setEditing(true)}>
              <Edit2 size={16} /> İletişim Bilgilerini Güncelle
            </button>
          </div>
        ) : (
          /* ================= DÜZENLEME MODU (FORM) ================= */
          <div className="profile-table-wrapper">
            <div style={{ marginBottom: '16px', fontSize: '15px', fontWeight: 'bold', color: '#1e293b', borderBottom: '2px solid #e2e8f0', paddingBottom: '12px' }}>
              Bilgileri Düzenle
            </div>
            
            <form onSubmit={handleSave}>
              <label style={{ color: "#475569", fontSize: "13px", fontWeight: "600" }}>E-posta Adresi
                <input 
                  type="email" 
                  className="form-input-modern"
                  value={formData.email} 
                  onChange={e => setFormData(prev => ({...prev, email: e.target.value}))} 
                  placeholder="E-posta adresiniz..." 
                />
              </label>

              <label style={{ color: "#475569", fontSize: "13px", fontWeight: "600" }}>Tebligat Adresi
                <textarea 
                  rows="3" 
                  className="form-input-modern"
                  style={{ resize: "vertical" }}
                  value={formData.notification_address} 
                  onChange={e => setFormData(prev => ({...prev, notification_address: e.target.value}))} 
                  placeholder="Resmi tebligat adresiniz..." 
                />
              </label>

              <button type="submit" className="btn-modern btn-save">
                <Save size={16} /> Kaydet
              </button>
              <button type="button" className="btn-modern btn-cancel" onClick={() => { setEditing(false); loadProfile(); }}>
                <X size={16} /> İptal Et
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}